import React, { Component } from 'react'

class FeedbackForm extends Component {
    constructor(props) {
        super(props);
        this.feedbackLink = "https://docs.google.com/forms/d/e/1FAIpQLScisRu1awoDURmBHCF0fryJtMJPydtZV8VP8-CkqhE1ZR3olg/viewform?embedded=true";
    }

    render() {
        return (
            <div id="feedback-form">
                <iframe src={this.feedbackLink} width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>        );
            </div>
        );
    }
}

export default FeedbackForm;


// WEBPACK FOOTER //
// ./src/components/FeedbackForm.js